<template>
  <div class="wrapper">
    <!-- Modal imprimir etiqueta-->
    <b-modal
      title="Imprimir Etiqueta"
      size="sm"
      class="modal-primary"
      v-model="modalShown"
      hide-footer
    >
      <b-form @submit.prevent="printLabel">
        <b-form-group description label="Tipo Etiqueta">
          <b-form-select
            v-model="$v.typeLabel.$model"
            :state="$v.typeLabel.$dirty ? !$v.typeLabel.$error : null"
          >
            <option value="">Seleccione</option>
            <option value="1">Etiqueta 4x6 pulgadas</option>
            <option value="2">Etiqueta 4x3 pulgadas</option>
            <option value="3">Bodega</option>
            <option value="4">10x15 Landscape</option>
            <option value="5">10x15 V(UN)</option>
            <option value="6">Etiqueta 10x15 Landscape (P)</option>
            <option value="7">10x15 V(UN-C)</option>
          </b-form-select>
        </b-form-group>

        <b-form-group>
          <label>Numero de etiquetas a imprimir</label>

          <b-form-input
            type="text"
            :state="$v.numberLabel.$dirty ? !$v.numberLabel.$error : null"
            v-model="$v.numberLabel.$model"
            placeholder=""
          >
          </b-form-input>
        </b-form-group>

        <b-button type="submit" variant="primary">Imprimir</b-button>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import Vue from "vue";
import miniToastr from "mini-toastr";
import { setup, Printer } from "../../assets/js/printFunctions.js";

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

Vue.use(miniToastr);

import {
  required,
  numeric,
  minLength,
  between
} from "vuelidate/lib/validators";

export default {
  name: "printContent",
  created() {},
  data() {
    return {
      data: 0,
      modalShown: false,
      numberLabel: 0,
      typeLabel: "",
      contentPrint: ""
    };
  },
  validations: {
    numberLabel: {
      required,
      numeric
    },
    typeLabel: {
      required
    }
  },
  methods: {
    printLabel() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        miniToastr.info("Campos requeridos o inválidos en el formulario.", "");
      } else {
        Printer(this.contentPrint, this.typeLabel, this.numberLabel);
        this.modalShown = false;
      }
    }
  },
  mounted() {
    setup();
  }
};
</script>
